import {
  resizeFuncCheck,
  resizeFunc,
  resizecheck
} from './_resizecheck';

var jsMBtn, varGlobalNavH, getHeadH, btnFlag, scrollpos;
export function headerFunc() {
  jsMBtn = $('#jsMBtn');
  varGlobalNavH = $('#headJs');
  jsMBtn.on('click', function () {
    btnFlag = varGlobalNavH.css('top');
    getHeadH = $('#header').outerHeight(true);
    if (btnFlag === '0px') {
      varGlobalNavH.addClass('open').css('top', getHeadH);
      $(this).addClass('active');
      scrollpos = $(window).scrollTop();
      $('body').addClass('fixedBody').css({
        'top': -scrollpos
      });
    } else {
      $(this).removeClass('active');
      varGlobalNavH.removeClass('open').css('top', 0);
      $('body').removeClass('fixedBody').css({
        'top': 0
      });
      window.scrollTo(0, scrollpos);
    }
  });
}